import { ref } from 'vue'
import { defineStore } from 'pinia'
import type {
  Url, Town, DomNodes, DoctorList,
} from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore.types'

const useCommonStore = defineStore('commonStore', () => {
  const url = ref<Url>({
    map: '',
    doctorList: '',
  })
  const town = ref<Town>({
    id: 0,
    name: '',
    translit: '',
    regionalCenter: {
      id: 0,
      name: '',
      translit: '',
    },
  })
  const domNodes = ref<DomNodes>({
    list: '',
    head: '',
    lpuAd: '',
    pagination: '',
    breadcrumbs: '',
    scrollTarget: '',
    doctorsListInfo: '',
    titleSpeciality: '',
    cardsContainer: '',
  })
  const doctorList = ref<DoctorList>({
    isSeoEnabled: false,
    hasMetro: false,
  })

  const updateUrl = (newUrl: Partial<Url>) => {
    url.value = { ...url.value, ...newUrl }
  }

  const updateTown = (newTown: Partial<Town>) => {
    town.value = { ...town.value, ...newTown }
  }

  const updateDomNodes = (newDomNodes: Partial<DomNodes>) => {
    domNodes.value = { ...domNodes.value, ...newDomNodes }
  }

  const updateDoctorList = (newDoctorList: Partial<DoctorList>) => {
    doctorList.value = { ...doctorList.value, ...newDoctorList }
  }

  return {
    url,
    town,
    domNodes,
    doctorList,
    updateUrl,
    updateTown,
    updateDomNodes,
    updateDoctorList,
  }
})

export default useCommonStore
